export const DOUBLE = "DOUBLE";
export const LONG = "LONG";
export const ENUM = "ENUM";
export const EQ = "EQ";
export const IN = "IN";
export const INTEGER = "INTEGER";
export const CUSTOM_FIELD = "CUSTOM_FIELD";
export const EXTENDED_FIELD = "EXTENDED_FIELD";
export const ENUM_TYPES = ['CUSTOM_ENUM', 'STANDARD_STRING', 'STANDARD_ENUM', 'ENUM'];
export const NUM_TYPES = [INTEGER, DOUBLE, LONG];

export const INCLUDE = "include";
export const EXCLUDE = "exclude";

export const INPUT_EMPTY = "INPUT_EMPTY";
export const SECOND_INPUT_SMALLER = "SECOND_INPUT_SMALLER";
export const MULTI_SELECT = "MULTI_SELECT";
export const MULTI_SELECT_TREE = "MULTI_SELECT_TREE";

export const OPERATORS = {
  IN: "IN",
  NOT_IN: "NOT_IN",
};

export const SKU = "SKU";
export const STORE = "STORE";
export const CONCEPT = "CONCEPT";
export const ZONE = "ZONE";

export const CATEGORY = "CATEGORY";
export const PRODUCT_ATTRIBUTE = "PRODUCT_ATTRIBUTE";
export const BRAND = "BRAND";
export const STORE_FILTER = 'STORE_FILTER';

export const UPLOAD_FAIL = "UPLOAD_FAIL";
export const UPLOAD_LIMIT_EXCEEDED = "UPLOAD_LIMIT_EXCEEDED";
export const UNSUPPORTED_CSV_HEADER = "UNSUPPORTED_CSV_HEADER";
export const EMPTY_CSV_FILE = "EMPTY_CSV_FILE";

export const EXTERNAL_SEARCH_ENABLED_ITEMS = [CATEGORY, PRODUCT_ATTRIBUTE];
export const CUSTOMER_SEGMENT_FILTER = 'CUSTOMER_SEGMENT_FILTER';
export const ZONE_FILTER = 'ZONE_FILTER';
export const CONCEPT_FILTER = 'CONCEPT_FILTER';
export const SUPPLEMENTARY_PROGRAM_META_SELECTION =
  'SUPPLEMENTARY_PROGRAM_META_SELECTION';

export const STRING = "STRING";
export const CONTAINS = "CONTAINS";
export const STARTS_WITH = "STARTS_WITH";
export const ENDS_WITH = "ENDS_WITH";
export const EXACT = "EXACT";
export const INPROGRESS = 'INPROGRESS';
export const UPLOAD = 'UPLOAD';
export const FAILURE = 'FAILURE';
export const SUCCESS = 'SUCCESS';
export const UPLOAD_FAILED = 'Upload failed';
export const SELECT_STORE = 'Select store';
export const CART_PROMOTIONS = 'cart-promotion';
export const REQUEST = 'REQUEST';
export const ENTRY_TRIGGER_EVENT_ATTRIBUTE = 'entryTriggerEventAttribute';